import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/export-purchase-transaction.request.dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ListPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/list-purchase-transaction.request.dto';
import { PurchaseTransactionResponseDto } from '@domain/purchase-transaction/dtos/purchase-transaction.response.dto';
import { SummaryPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/summary-purchase-transaction.request.dto';
import { SummaryPurchaseTransactionResponseDto } from '@domain/purchase-transaction/dtos/summary-purchase-transaction.response.dto';

@Injectable({
  providedIn: 'root',
})
export class PurchaseTransactionService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('purchase/transaction');
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<PurchaseTransactionResponseDto>>(
      queryUrl,
      {},
    );
  }

  list(request: ListPurchaseTransactionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<PurchaseTransactionResponseDto>>
    >(queryUrl, { params: { ...request } });
  }

  export(request: ExportPurchaseTransactionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/export`;
    return this.http.post<ApiResponse<ExportListResponse>>(queryUrl, request);
  }

  summary(request: SummaryPurchaseTransactionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/summary`;
    return this.http.get<ApiResponse<SummaryPurchaseTransactionResponseDto>>(
      queryUrl,
      { params: { ...request } },
    );
  }
}
